
import { useState } from 'react';
import MegaMenu from './MegaMenu';

export default function MainNav() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState<string | null>(null);

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    setIsMobileMenuOpen(false);
    setMobileSubmenuOpen(null);
  };

  return (
    <>
      <nav className="bg-white border-b border-gray-200 relative z-50">
        <div className="container mx-auto px-6">
          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center justify-center gap-12">
            <div
              className="relative group"
              onMouseEnter={() => setActiveMenu('services')}
              onMouseLeave={() => setActiveMenu(null)}
            >
              <a
                href="/content-production"
                className="py-6 font-bold text-gray-900 hover:text-blue-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                서비스 소개
                <i className="ri-arrow-down-s-line"></i>
              </a>
              {/* Invisible bridge to prevent gap */}
              <div className="absolute left-0 right-0 h-4 top-full"></div>
              {activeMenu === 'services' && <MegaMenu type="services" />}
            </div>

            <div
              className="relative group"
              onMouseEnter={() => setActiveMenu('solutions')}
              onMouseLeave={() => setActiveMenu(null)}
            >
              <a
                href="/integrated-solution"
                className="py-6 font-bold text-gray-900 hover:text-blue-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                솔루션
                <i className="ri-arrow-down-s-line"></i>
              </a>
              {/* Invisible bridge to prevent gap */}
              <div className="absolute left-0 right-0 h-4 top-full"></div>
              {activeMenu === 'solutions' && <MegaMenu type="solutions" />}
            </div>

            <a
              href="/portfolio"
              className="py-6 font-bold text-gray-900 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              포트폴리오
            </a>

            <a
              href="/news"
              className="py-6 font-bold text-gray-900 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              뉴스
            </a>

            <a
              href="/kr-story"
              className="py-6 font-bold text-gray-900 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              KR스토리
            </a>
          </div>

          {/* Mobile Navigation */}
          <div className="lg:hidden flex items-center justify-between py-4">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-900 cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-[120px] bg-white z-50 overflow-y-auto">
          <div className="container mx-auto px-6 py-6">
            {/* Services */}
            <div className="border-b border-gray-200 pb-4 mb-4">
              <button
                onClick={() => setMobileSubmenuOpen(mobileSubmenuOpen === 'services' ? null : 'services')}
                className="w-full flex items-center justify-between py-3 font-bold text-gray-900 cursor-pointer"
              >
                서비스 소개
                <i className={`ri-arrow-${mobileSubmenuOpen === 'services' ? 'up' : 'down'}-s-line`}></i>
              </button>
              {mobileSubmenuOpen === 'services' && (
                <div className="pl-4 space-y-3 mt-3">
                  <a
                    onClick={() => handleNavigation('/content-production')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-film-line text-secondary"></i>
                    콘텐츠 제작
                  </a>
                  <a
                    onClick={() => handleNavigation('/live-streaming')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-live-line text-secondary"></i>
                    라이브 스트리밍
                  </a>
                  <a
                    onClick={() => handleNavigation('/on-site-service')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-map-pin-line text-secondary"></i>
                    현장 출장
                  </a>
                  <a
                    onClick={() => handleNavigation('/studio-consulting')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-building-4-line text-secondary"></i>
                    스튜디오 컨설팅
                  </a>
                  <a
                    onClick={() => handleNavigation('/ai-content')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-robot-2-line text-secondary"></i>
                    AI 콘텐츠 제작
                  </a>
                </div>
              )}
            </div>

            {/* Solutions */}
            <div className="border-b border-gray-200 pb-4 mb-4">
              <button
                onClick={() => setMobileSubmenuOpen(mobileSubmenuOpen === 'solutions' ? null : 'solutions')}
                className="w-full flex items-center justify-between py-3 font-bold text-gray-900 cursor-pointer"
              >
                솔루션
                <i className={`ri-arrow-${mobileSubmenuOpen === 'solutions' ? 'up' : 'down'}-s-line`}></i>
              </button>
              {mobileSubmenuOpen === 'solutions' && (
                <div className="pl-4 space-y-3 mt-3">
                  <a
                    onClick={() => handleNavigation('/integrated-solution')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-stack-line text-secondary"></i>
                    통합 운영 솔루션
                  </a>
                  <a
                    onClick={() => handleNavigation('/university-solution')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-team-line text-secondary"></i>
                    협회 제작 사례
                  </a>
                  <a
                    onClick={() => handleNavigation('/public-solution')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-government-line text-secondary"></i>
                    공공 제작 사례
                  </a>
                  <a
                    onClick={() => handleNavigation('/enterprise-solution')}
                    className="flex items-center gap-3 py-2 text-gray-700 cursor-pointer"
                  >
                    <i className="ri-building-line text-secondary"></i>
                    기업 제작 사례
                  </a>
                </div>
              )}
            </div>

            {/* Other Menu Items */}
            <a
              onClick={() => handleNavigation('/portfolio')}
              className="block py-3 font-bold text-gray-900 border-b border-gray-200 cursor-pointer"
            >
              포트폴리오
            </a>
            <a
              onClick={() => handleNavigation('/news')}
              className="block py-3 font-bold text-gray-900 border-b border-gray-200 cursor-pointer"
            >
              뉴스
            </a>
            <a
              onClick={() => handleNavigation('/kr-story')}
              className="block py-3 font-bold text-gray-900 cursor-pointer"
            >
              KR스토리
            </a>
          </div>
        </div>
      )}
    </>
  );
}
